import { apiV3Client } from './BaseRepository';

export function fetchCareerProjection(filter = {}) {
  return apiV3Client.post('careers/_projection', filter);
}

export function fetchCareerAssessment(filter = {}) {
  return apiV3Client.post('careers/_assess', filter);
}
